// eslint-disable-next-line import/prefer-default-export
export const url = { API_URL: process.env.REACT_APP_SERVER };
